// Description: Use these anchors to replace data dynamically in text
export const DeveloperMessageAnchors = {
    user_count: "##USER_COUNT##",
    user_id: "##USER_ID##",
};
  
export const DeveloperSuccessMessages = {
    success_creating_user: "User created successfully",
    success_creating_multiple_users: `${DeveloperMessageAnchors.user_count} users created successfully.`,
    success_creating_org: "Organization created and users added successfully.",
    success_adding_user: "User added to organization successfully.",
};
  
export const DeveloperErrorMessages = {
    error_API_error: "Can not connect to the Test API. Please ensure TEST_API_ENABLED=true when you building the collection server.",
    error_duplicate_org: "Organization already exists. Please try a different organization domain.",
    error_forbidden: "Your email domain is under an organization. Please create and add the user via organization tab.",
    error_user_already_in_org: "User already exists in the organization. Please try a different userID.",
    error_user_already_exists: "User already exists. Please try a different userID.",
    error_user_already_exists_multiple: `User ${DeveloperMessageAnchors.user_id} already exists. ${DeveloperMessageAnchors.user_count} users created successfully.`,
    error_creating_user: "There was an error creating the user.",
    error_creating_multiple_users: `There was an error creating one or more users. ${DeveloperMessageAnchors.user_count} users created successfully.`,
    error_creating_org: "There was an error creating the organization or adding users.",
    error_adding_user: "There was an error adding the user to the organization."
};
  
export const DeveloperWarningMessages = {
    warning_wrong_port: "You are using Preveil Express. Please switch to Preveil to use this feature."
};
